import React from "react";
import { RxCross2 } from "react-icons/rx";
import cn from "../../../lib/cn";
import H4 from "../../../shared/typography/H4";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import Table from "./Table";

const Approve = ({
    tableData,
    type,
    img,
    showClose = true,
    OnApproved,
    minHeight,
    imgClass,
    onClose = () => {},
}) => {
    return (
        <div className=" lg:flex  h-[50vh] md:h-[80vh] lg:flex-col lg:w-full bg-white  items-center">
            <div
                className={cn(
                    "  px-3 bg-white md:bg-transparent md:top-3 rounded-t-1.5 md:h-[100vh] pt-[5rem] flex flex-col w-full lg:justify-center  lg:flex-row items-center md:overflow-y-scroll",
                    minHeight
                )}
            >
                <div className="w-full  lg:mx-3 flex flex-col items-center justify-center">
                    {showClose && (
                        <div className="flex justify-end items-center text-lg w-full pr-1">
                            <div role="button" onClick={() => onClose()}>
                                <RxCross2 />
                            </div>
                        </div>
                    )}
                    <img
                        src={img}
                        alt="welcome"
                        className={cn("w-90", imgClass)}
                    />

                    {type === 0 ? (
                        <>
                            <P className="m-1 text-xl text-center md:text-2xl xl:!text-2xl">
                                We’re glad you’re choosing solar
                                <span className="font-semibold text-xxl md:text-5xl">
                                    {" "}
                                    LEASE{" "}
                                </span>
                            </P>
                        </>
                    ) : (
                        <P className="m-1 text-xl text-center  md:text-2xl xl:text-2xl">
                            We’re glad you’re
                            <span className="text-xxl mx-0.4 md:text-3xl font-semibold">
                                Buying
                            </span>
                            Solar with us
                        </P>
                    )}

                    <div
                        className={cn(
                            "flex justify-between lg:hidden items-center bg-linear-blue-white py-1 my-1 px-2 w-[90%] sm:w-full rounded-2xl  gap-2"
                        )}
                    >
                        <div className="flex-col text-center items-center justify-center">
                            <H4 className="text-white font-medium">60 KWp</H4>
                            <p className="text-sm text-white">Plant Size</p>
                        </div>
                        <div
                            className={`bg-white w-0.1 min-h-[5rem]  max-h-[6rem]
                                            `}
                        />
                        <div className="flex-col text-center items-center justify-center">
                            <H4 className="text-white font-medium">41%</H4>
                            <p className="text-sm text-white">Monthly Saving</p>
                        </div>
                    </div>
                </div>
                <div className="w-[90%] sm:w-full  lg:mx-3 lg:flex lg:flex-col items-center justify-center">
                    <p className="text-xs lg:hidden">
                        Let’s double check your details & continue!
                    </p>
                    <div className="my-2 w-full p-2 bg-gray-100 rounded-2xl">
                        <Table
                            heading={["Description", "Plan Details"]}
                            headingRowClass="bg-white py-1 px-1 rounded-2xl"
                            RowClass="p-1 border-b-blue-300"
                            tableData={tableData}
                        />
                    </div>
                    <div
                        className={cn(
                            " hidden lg:flex justify-between items-center bg-linear-blue-white py-1 my-1 px-2 w-full rounded-2xl  gap-2"
                        )}
                    >
                        <div className="flex-col text-center items-center justify-center">
                            <H4 className="text-white font-medium">60 KWp</H4>
                            <p className="text-sm text-white">Plant Size</p>
                        </div>
                        <div
                            className={`bg-white w-0.1 min-h-[5rem]  max-h-[6rem]
                                            `}
                        />
                        <div className="flex-col text-center items-center justify-center">
                            <H4 className="text-white font-medium">41%</H4>
                            <p className="text-sm text-white">Monthly Saving</p>
                        </div>
                    </div>
                    <Button
                        className="w-full px-1 mb-[8rem] md:mb-2 rounded-[3rem]"
                        onClick={OnApproved}
                    >
                        Accept
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Approve;
